module.exports = __webpack_public_path__ + "img/5.205e2faf.webp";